import React, {useEffect, useState} from 'react'
import { CircularProgress, Typography, Button } from '@material-ui/core'
import { FaFileDownload } from 'react-icons/fa'
import { SiTableau } from 'react-icons/si'
import DataUsageIcon from '@material-ui/icons/DataUsage'
import Cookies from 'js-cookie'

const TableauPort = ({viz, pageName}) => {
    const token = Cookies.get("token")
    const [srcUrl, setSrcURL] = useState("")
    const [dbOwner, setDbOwner] = useState("")

    const getViz = () => {
        setSrcURL(`https://api.v2.smartdash.com/v2/tbsrv_dev.cfm?viz=${viz}&token=${token}`)
    }

    useEffect(() => getViz(), [])

    return (
        <div style={{overflow: "hidden", width: "100%", margin: "2em"}}>            
            <Typography style={{display: "flex", alignItems: "center", color: "#fff", fontWeight: "bold"}}>
                <SiTableau style={{marginRight: "5px"}}/>
                <span>{pageName.toUpperCase()}</span>
            </Typography>
            <div>
                <iframe
                    src={srcUrl}
                    seamless
                    scrolling="yes"
                    // className="tableau-frame"                           
                    style={{minHeight: "1000px", width: "101.2%", borderWidth: 0, position: "static", overflow: "hidden"}}
                >
                </iframe>
            </div>
        </div>
    )
}

export default TableauPort
